import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-caacd3fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hightText" }, "Six", -1))
const _hoisted_4 = { class: "login" }
const _hoisted_5 = { class: "mobile_header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hightText" }, "Six", -1))

import SignIn from "@/views/SignIn.vue";
import SignUp from "@/views/SignUp.vue";
import { store } from "@/utils/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const handleOpenMobileSign = () => {
  store.handleOpenMobileLogin();
};
const handleOpenMobileRegister = () => {
  store.handleOpenMobileRegister();
};
const handleCloseLogin = () => {
  store.handleCloseRegister();
  store.handleCloseLogin();
};
const handleOpenRegister = () => {
  store.handleCloseLogin();
  store.handleOpenRegister();
};
const handleCloseRegister = () => {
  store.handleCloseRegister();
  store.handleOpenLogin();
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _createTextVNode("liv ")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/register",
          class: "register"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Register For Business ")
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          onClick: handleCloseRegister,
          class: "sign hightText"
        }, "Sign Up")
      ]),
      _createVNode(SignIn, {
        visible: _unref(store).login,
        handleOpenRegister: handleOpenRegister,
        handleClose: handleCloseLogin
      }, null, 8, ["visible"]),
      _createVNode(SignUp, {
        visible: _unref(store).register,
        handleClose: handleCloseRegister
      }, null, 8, ["visible"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _hoisted_7,
          _createTextVNode("liv ")
        ]),
        _: 1
      }),
      _createElementVNode("div", { class: "login" }, [
        _createElementVNode("div", {
          onClick: handleOpenMobileRegister,
          class: "mobile_register"
        }, " Register For Business "),
        _createElementVNode("div", {
          onClick: handleOpenMobileSign,
          class: "sign hightText"
        }, "Sign Up")
      ])
    ])
  ], 64))
}
}

})